// Public navigation hints only. These never grant organization access.
const safeSlug = value => typeof value === 'string' && /^[a-z0-9-]{1,160}$/i.test(value) ? value : '';

export function clientEntryUrl({ studio, search = '', fallbackStudio = '' } = {}) {
  const params = new URLSearchParams(search);
  // A loaded server context wins over URL/storage hints from another app.
  const brand = safeSlug(studio ? studio.brand_network?.slug : params.get('brand'));
  const slug = safeSlug(studio ? studio.slug : params.get('studio') || fallbackStudio);
  // `view=story` also prevents an installed Brand app from auto-launching its
  // remembered Studio login again immediately after logout.
  if (brand) return `/brand/${brand}?view=story`;
  if (slug) return `/studio/${slug}`;
  return '/';
}

export function guestClientEntry(search = '') {
  let fallbackStudio = '';
  try { fallbackStudio = window.localStorage.getItem('tps:client-identity:last') || ''; } catch { /* optional hint */ }
  return clientEntryUrl({ search, fallbackStudio });
}
